var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmergency = function SvgEmergency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5 20.75v-6.133L5.187 17.69l-1.5-2.603L9 12 3.687 8.938l1.5-2.602L10.5 9.409V3.25h3v6.158l5.314-3.071 1.5 2.601L15 12l5.314 3.086-1.5 2.603-5.314-3.072v6.133z"
  })));
};
export default SvgEmergency;